module.exports = __webpack_public_path__ + "media/images/icons/phone-hangup-26150ba7c82996773d939a6ed30b5ead.svg";